import { getStream } from '../../../../../shared/api/magellan/stream';
import type Stream from '../../../../../shared/entities/Stream';
import { useSetPageTitle } from '../../../../../shared/hooks/useSetPageTitle.hook';
import { queryClient } from '../../../../../shared/infra/queryClient';
import { removeEmoji } from '../../../../../shared/utils/strings';
import { useStreamQuery } from './streams.hook';

export function useStream(id: number) {
  const queryKey = [getStream.name, id];

  const { data: stream } = useStreamQuery(id);

  useSetPageTitle(`Flux - ${removeEmoji(stream?.name || '')}`);

  const decrementPendingDecisionCount = () => {
    queryClient.setQueryData(queryKey, (prev: Stream) => {
      const pendingDecisionCount = prev.pendingDecisionCount - 1;
      if (pendingDecisionCount < 0) {
        throw new Error(
          'Invalid pendingDecisionCount, should be positive or 0',
        );
      }

      return {
        ...prev,
        pendingDecisionCount,
      };
    });
  };

  const incrementPendingDecisionCount = () => {
    queryClient.setQueryData(queryKey, (prev: Stream) => ({
      ...prev,
      pendingDecisionCount: prev.pendingDecisionCount + 1,
    }));
  };

  return {
    stream,
    decrementPendingDecisionCount,
    incrementPendingDecisionCount,
  };
}
